import React, {useContext} from 'react';
import getConfig from 'next/config';

import initPolyglot from '~/src/utilities/libs/polyglot';
import {SettingsContext} from '~/src/components/context/SettingsContext';
import {classNames} from '~/src/utilities/helpers/css';

import css from './ReportDialog.module.scss';
import i18nStrings from './ReportDialog.i18n.json';

const getTranslation = initPolyglot(i18nStrings);
const {publicRuntimeConfig: config} = getConfig();

const getHref = () => {
    if (process.browser) {
        const emailAddress = config.report.emailAddress;
        const href = window.location.href;
        return `mailto:${emailAddress}?subject=${getTranslation('reportSubject')}&body=${getTranslation('reportBody', {href: href})} `;
    }
};

const ReportDialog = () => {
    const {siteArea} = useContext(SettingsContext);
    const className = classNames(css, 'reportDialog', siteArea);

    return (
        <div className={className}>
            {getTranslation('errorFound')}

            <a className={css.reportLink} href={getHref()}>
                {getTranslation('reportNow')}
            </a>
        </div>
    );
};

export default ReportDialog;
